//import "touchpolyfill";
import Doms from "oc-commons/Doms.js";
import DeviceDetection from "oc-commons/DeviceDetection";
import Dragswitch from "../Dragswitch.js";
import "../ios10UserScalablePolyfill.js";

/**
 * Pantouch ergänzt jQuery um neue Events, die sowohl für Desktop als auch Mobile funktionieren, also Touch und Click vereinheitlichen.
 * Man sollte generell die Pantouch Events verwenden und nicht Click oder Touch, ausser man möchte explizit nur diese Events haben.
 *
 * ### Events
 *
 * tap - a single tap or click (only left button / single Touch)
 * hold - user holds the item clicked or touched. The event will fire every 20 milliseconds by default.  (only left button / single Touch)
 * dragdown - like mousedown (only left button / single Touch)
 * dragup - like mouseup (only left button / single Touch)
 * dragmove - like mousemove with pressed left button (only left button / single Touch)
 * dragenter - entering an element during drag (only left button / single Touch)
 * dragleave - leaving an element during drag (only left button / single Touch)
 *
 * For other gestures use a gesture library like hammerjs
 * For a polyfill for windows 10 with pointer api see touchpolyfill.js
 *
 * see http://www.html5rocks.com/en/mobile/touchandmouse
 *
 * ### Beispiel
 * @example
 * $('#MyButton').on('tap',()=>console.log('I was tapped (clicked or touched)'));
 */
(function Pantouch($) {

    const registerkey = '__pantouch__';

    // ---------------------
    // Ein sehr schwieriges Thema ist die gleichzeitige Unterstützung von Touch und Mouse Devices.
    // Da es Devices gibt, die beide Events feuern können, muss beides unterstützt werden.
    // Feature-Detection geht dabei nicht. Best Practise ist es, stets auf beide Event-Arten zu lauschen.
    // Dummerweise werden dann auf einigen Devices die gleichen Events einmal als Touch und einmal als
    // Mouse Event geworfen, was zu doppeltem Aufruf der Listener in der Anwendung führt.
    // Eine mögliche Lösung ist event.preventDefault() im Touch-Listener (so war das hier früher).
    // Problem dabei ist, dass dann auch Dinge wie Fenster-Scrolling nicht mehr funktionieren.
    // Daher jetzt folgende Lösung: Es wird auf beides gelauscht, aber sobald ein Touch-Event
    // reinkommt, werden alle Mouse-Events für 3 Sekunden ignoriert. Der User kann also zwischen
    // den Eingabemethoden wechseln, wenn er wenigstens 3 Sekunden wartet, was ok sein sollte.
    // const MOUSE = 1;
    // const TOUCH = 2;
    // let lastTimeTouchOccured = 0;
    // function ignoreInput(inputtype) {
    //     const now = Date.now();
    //     if (inputtype===TOUCH) {
    //         lastTimeTouchOccured = now;
    //         return false;
    //     }
    //     return now-lastTimeTouchOccured<1 //3000;
    // }

    // weil die obige Logik bei TWINS zu Problemen führt (Droppen eines Interieurs, will man es dann
    // direkt noch mal mouse-down und up/down moven, wird statt dessen das Orbitcontrol aktiv und man
    // bewegt die Kamera, und man kann erst nach 3 Sekunden das Objekt verschieben), jetzt die folgende
    // Änderung: es wird gespeichert, welche art von event zuerst reinkam, und die gewinnt dann für
    // 3 Sekunden.
    const MOUSE = 1;
    const TOUCH = 2;
    let lastInputOccured = 0;
    let lastInputType = 0;
    const MAX_WAIT_INPUT_TYPE_BLOCK_TIME = 3000;
    function ignoreInput(inputtype) {
        const now = Date.now();
        const timeout = now-lastInputOccured>MAX_WAIT_INPUT_TYPE_BLOCK_TIME;
        const sameInputType = lastInputType==0 || inputtype===lastInputType;
        // console.log('ignoreInput',{now,lastInputOccured,delta:now-lastInputOccured,MAX_WAIT_INPUT_TYPE_BLOCK_TIME,timeout,inputtype,lastInputType,sameInputType});
        lastInputOccured = now;
        if (lastInputType==9 || timeout) {
            lastInputType = inputtype;
            return false;
        }
        if (sameInputType) {
            return false;
        }
        return true;
    }
    // ---------------------
    
    // Der Safari scheint Probleme mit unserer DragArea zu haben. Das ist der Hackebeil-Fix
    if (DeviceDetection.safari) document.onselectstart = function(){ return false; }
    
    function getOriginalEvent(event) {
        return event.originalEvent||event;
    }

    function registerForCleanup(jqThis,eventName,callback,housekeeper) {
        let pantouchdata = jqThis.data(registerkey);
        if (!pantouchdata) {
            pantouchdata = {};
            jqThis.data(registerkey,pantouchdata);
        }
        if (!pantouchdata[eventName]) {
            pantouchdata[eventName] = [];
        }
        const eventData = pantouchdata[eventName];
        eventData.push({callback:callback,housekeeper:housekeeper});
    }

    function cleanup(jqThis,eventName,callback) {
        const pantouchdata = jqThis.data(registerkey);
        if (!pantouchdata) {
            return;
        }
        if (!callback && !eventName) {
            jqThis.removeData(registerkey);
            return;
        }
        if (!pantouchdata[eventName]) {
            return;
        }
        if (!callback) {
            const eventData = pantouchdata[eventName];
            eventData.forEach(function(entry){
                entry.housekeeper.cleanup();
            });
            delete pantouchdata[eventName];
            if (_.keys(pantouchdata).length===0) {
                jqThis.removeData(registerkey);
            }
            return;
        }
        const eventData = pantouchdata[eventName];
        const eventDataNew = [];
        eventData.forEach(function(entry){
            if (entry.callback!==callback) {
                eventDataNew.push(entry);
            } else {
                entry.housekeeper.cleanup();
            }
        });
        if (eventDataNew.length===0) {
            delete pantouchdata[eventName];
        } else {
            pantouchdata[eventName] = eventDataNew;
        }
        if (_.keys(pantouchdata).length===0) {
            jqThis.removeData(registerkey);
        }
    }

    function Housekeeper(jqThis,pantouchEventName,pantouchCallback) {
        let cleanups = [];
        const self = {
            on(jqThis,jqEventName,jqCallback) {
                jqThis.on(jqEventName,jqCallback);
                const offCallback = ()=>jqThis.off(jqEventName,jqCallback);
                cleanups.push(offCallback);
                return ()=>{
                    offCallback();
                    const i = cleanups.indexOf(offCallback());
                    if (i>=0) {
                        cleanups.splice(i,1);
                    }
                }
            },
            cleanup() {
                cleanups.forEach(cleanup=>cleanup());
                cleanups=null;
            },
            addCleanupTask(task) {
                cleanups.push(task);
            }
        };
        registerForCleanup(jqThis,pantouchEventName,pantouchCallback,self);
        return self;
    }

    const $window = $(window);

    // ------------------------------------------------------------------------------------------------------------
    // ff and chrome both handle e.which and e.buttons in some mutually fucked up way wrong for mousemove events
    // only solution is to track mousebutton state on mousedown and mouseup events in a global variable
    let isLeftMouseButtonPressed = false;
    let isMouseDown = false;
    let isDragging = false;
    let blockDragMoveEvents = true;
    const dragStartPosition = {x: 0, y: 0};
    let dragWasMoved = false;

    function setLeftMouseButtonState(e) {
        if (typeof e.buttons!=='undefined') {
            // new W3C standard (IE9, Chrome)
            isLeftMouseButtonPressed = e.buttons && e.buttons === 1;
        } else if (typeof e.which!=='undefined') {
            // for FF
            isLeftMouseButtonPressed = e.which===1;
        } else {
            // for old browsers
            isLeftMouseButtonPressed = e.button === 1;
        }
    }
    // mouse press state is tracked globally (to be sure that it is not forgotten) and locally (because there it fires
    // before the global listener)
    // global:
    const preventContextMenuListener = ()=>false;
    let preventContextMenuListenerActive = false;
    $window.on('mousedown',function(event){
        isMouseDown = true;
        setLeftMouseButtonState(event);
        // prevent context menu from popping up during drag
        if (!preventContextMenuListenerActive && isLeftMouseButtonPressed) {
            preventContextMenuListenerActive = true;
            $window.on('contextmenu',preventContextMenuListener);
        }
    });
    $window.on('mouseup',function(event){
        setLeftMouseButtonState(event);
        isMouseDown = false;
        if (preventContextMenuListenerActive) {
            $window.off('contextmenu',preventContextMenuListener);
            preventContextMenuListenerActive = false;
        }
    });

    function leftMouseButtonOrSingleTouch(event) {
        const e = getOriginalEvent(event);
        const eventName = event.type;
        let isMousedownEvent = eventName=='mousedown';
        let isClickEvent = eventName=='click';
        let isMouseUpEvent = eventName=='mouseup' ;
        let isMouseMoveEvent = eventName=='mousemove';
        // local:
        if (isClickEvent) {
            return true;
        }
        if (isMousedownEvent) {
            isMouseDown = true;
            setLeftMouseButtonState(e);
        } else if (isMouseUpEvent) {
            isMouseDown = false;
            setLeftMouseButtonState(event);
        } else if (isMouseMoveEvent) {
            if (!isMouseDown) {
                isLeftMouseButtonPressed = false;
            }
        }
        return isLeftMouseButtonPressed
            || isDragging
            || (e.changedTouches && e.changedTouches.length == 1)
            || (e.targetTouches && e.targetTouches.length == 1);
    }
    // ------------------------------------------------------------------------------------------------------------

    function mapEvent(event) {
        const e = getOriginalEvent(event);
        const touchEvent = (e.changedTouches && e.changedTouches.length>0)
            ? e.changedTouches[0]
            : null;
        const pageX = touchEvent ? touchEvent.pageX : event.pageX;
        const pageY = touchEvent ? touchEvent.pageY : event.pageY;
        const target = touchEvent
            ? document.elementFromPoint(pageX, pageY)
            : e.target;
        event.target=target;
        event.pageX=pageX;
        event.pageY=pageY;
        event.isTouchEvent=touchEvent!=null;
        event.dragWasMoved = dragWasMoved;
        return event;
    }

    function dragEnterOrLeave(eventName,testFn) {
        return function(callback,data) {

            const $this = $(this);
            if ($this.length==0) {
                console.warn(eventName,'without element');
            }
            const housekeeper = Housekeeper($this,eventName,callback);
            const jqDocument = $(document);
            let wasInside;

            function reset() {
                wasInside = undefined;
            }

            function testEnter(event) {
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                const e = mapEvent(event);
                const inside = isInside($this,e);
                if (typeof wasInside!=='undefined' && testFn(inside,wasInside)) {
                    callback.call($this,e,data);
                }
                wasInside = inside;
            }

            function isInside(element,e) {
                const width = element.outerWidth();
                const height = element.outerHeight();
                if ( element.is(':visible') && width*height===0) {
                    console.error('DragDrop may not function correctly because the dragdrop container has width or height of 0!',element);
                }
                const offset = element.offset();
                let ok = offset.left<=e.pageX
                    && e.pageX<=offset.left+width
                    && offset.top<=e.pageY
                    && e.pageY<=offset.top+height
                    && (e.target === element[0] || $.contains( element[0], e.target ));

                return ok;
            }

            housekeeper.on(jqDocument,'mousemove',testEnter);
            housekeeper.on(jqDocument,'touchmove',testEnter);
            housekeeper.on(jqDocument,'mouseup',reset);
            housekeeper.on(jqDocument,'touchend',reset);
        }
    }

    function simpleBind(eventname,mouseevent,touchevent) {
        return function (callback,data) {
            const $this = $(this);
            const housekeeper = Housekeeper($this,eventname,callback);

            housekeeper.on($this,mouseevent,function(event){
                if (ignoreInput(MOUSE)) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                callback.call($this,mapEvent(event),data);
            });

            housekeeper.on($this,touchevent,function(event){
                if (ignoreInput(TOUCH)) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                callback.call($this,mapEvent(event),data);
            });
        };
    }

    const events = {

        // a single tap or click (only left button / single Touch)
        tap: function (callback, data) {
            const $this = $(this);
            const housekeeper = Housekeeper($this,'tap',callback);

            housekeeper.on($this,'click',function(event){
                if (ignoreInput(MOUSE)) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                //console.log('tap click');
                callback.call($(this),mapEvent(event),data);
            });

            let click = false;
            let firstEvent = null;
            const o = {x: 0, y: 0};

            housekeeper.on($this,'touchstart',function (event) {
                if (ignoreInput(TOUCH)) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                console.log('tap touchstart');
                const e = getOriginalEvent(event);
                firstEvent = e;
                click = true;
                o.x = e.changedTouches[0].pageX;
                o.y = e.changedTouches[0].pageY;
            });
            housekeeper.on($this,'touchmove',function (event) {
                if (ignoreInput(TOUCH)) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                const e = getOriginalEvent(event);
                if (click) {
                    const dx = e.changedTouches[0].pageX - o.x;
                    const dy = e.changedTouches[0].pageY - o.y;
                    if (Math.sqrt(dx * dx + dy * dy) > 10) {
                        click = false;
                    }
                }
            });
            housekeeper.on($this,'touchend',function (event) {
                if (ignoreInput(TOUCH)) {
                    return;
                }
                if (click) {
                    console.log('tap touchend');
                    callback.call($(this), {
                        originalEvent: event,
                        target: event.target,
                        pageX: o.x,
                        pageY: o.y,
                        timeStamp : event.timeStamp,
                    }, data);
                }
            });

        },

        // user holds the item clicked or touched. The event will fire every 20 milliseconds by default.  (only left button / single Touch)
        hold: function (callback, data) {
            const $this = $(this);

            const housekeeper = Housekeeper($this,'hold',callback);
            const dragswitch = new Dragswitch($this,'pantouch-hold')

            let originalEvent = null;
            let timeHandler = null;
            const o = {x: 0, y: 0};

            function start() {
                stop();
                o.x = originalEvent.pageX;
                o.y = originalEvent.pageY;
                timeHandler = setInterval(function(){
                    originalEvent.timeStamp = Date.now();
                    callback.call($this, originalEvent, data);
                }, (data && data.holdIntervallMs) || 20);
            }
            function stop() {
                if (timeHandler != null) {
                    clearInterval(timeHandler);
                    timeHandler = null;
                }
            }

            const jqDocument = $(document);

            housekeeper.on($this,'mousedown',function(event){
                if (ignoreInput(MOUSE)) {
                    return;
                }
                dragswitch.claimDragStream();
                if (!dragswitch.active()) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }

                const off = housekeeper.on(jqDocument,'mouseup',function(event){
                    off();
                    if (ignoreInput(MOUSE)) {
                        return;
                    }
                    if (!dragswitch.active()) {
                        return;
                    }
                    stop();
                });

                originalEvent = mapEvent(event);
                start();
                callback.call($this, originalEvent, data);
            });

            housekeeper.on($this,'mousemove',function (event) {
                if (ignoreInput(MOUSE)) {
                    return;
                }
                if (!dragswitch.active()) {
                    return;
                }
                if (!timeHandler) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    stop();
                }
                const e = mapEvent(event);
                const dx = e.pageX - o.x;
                const dy = e.pageY - o.y;
                if (Math.sqrt(dx * dx + dy * dy) > 10) {
                    stop();
                }
            });

            housekeeper.on($this,'touchmove',function (event) {
                if (ignoreInput(TOUCH)) {
                    return;
                }
                if (!dragswitch.active()) {
                    return;
                }
                if (!timeHandler) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    stop();
                }
                const e = mapEvent(event);
                const dx = e.pageX - o.x;
                const dy = e.pageY - o.y;
                if (Math.sqrt(dx * dx + dy * dy) > 10) {
                    stop();
                }
            });

            housekeeper.on($this,'touchstart',function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                const off = housekeeper.on(jqDocument,'touchend',(event)=>{
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    off();
                    if (ignoreInput(TOUCH)) {
                        return;
                    }
                    if (!dragswitch.active()) {
                        return;
                    }
                    stop();
                });

                if (ignoreInput(TOUCH)) {
                    return;
                }
                dragswitch.claimDragStream();
                if (!dragswitch.active()) {
                    return;
                }
                if (!leftMouseButtonOrSingleTouch(event)) {
                    stop();
                    return;
                }
                originalEvent = mapEvent(event);
                start();
                callback.call($this, originalEvent, data);
            });

            housekeeper.addCleanupTask(stop);
        },

        // like mousedown (only left button / single Touch)
        touchdown: simpleBind('touchdown','mousedown','touchstart'),

        // like mouseup (only left button / single Touch)
        touchup: simpleBind('touchup','mouseup','touchend'),

        // like mousedown especially for dragging (only left button / single Touch)
        dragdown: function (callback,data) {

            const $this = $(this);
            const housekeeper = Housekeeper($this,'dragdown',callback);
            let isDraggingThisListener = false;

            const doDown = (event,upevent)=>{
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                if (isDraggingThisListener) {
                    return;
                }
                if (/input|textarea|select|option|button/i.test(event.target.tagName)) {
                    return;
                }
                if (!isDragging) {
                    isDragging = true;
                    blockDragMoveEvents = false;
                    dragWasMoved = false;
                }
                isDraggingThisListener = true;
                const e = mapEvent(event);
                dragStartPosition.x = e.pageX;
                dragStartPosition.y = e.pageY;
                callback.call($this,e,data);
                const off = housekeeper.on($(window),upevent,(event)=>{
                    off();
                    isDraggingThisListener = false;
                    if (isDragging) {
                        isDragging = false;
                        _.defer(()=>dragWasMoved = false);
                    }
                });
            }

            housekeeper.on($this,'mousedown',function(event){
               if (ignoreInput(MOUSE)) {
                    return;
                }
                doDown(event,'mouseup');
            });

            housekeeper.on($this,'touchstart',function(event){
                if (ignoreInput(TOUCH)) {
                    return;
                }
                doDown(event,'touchend');
            });
        },

        // like mouseup especially for dragging (only left button / single Touch)
        dragup: function (callback,data) {
            const $this = $(this);
            const housekeeper = Housekeeper($this,'dragup',callback);

            housekeeper.on($window,'mouseup',function(event){
                if (ignoreInput(MOUSE)) {
                    return;
                }
                blockDragMoveEvents = true;
                if (isDragging) {
                    callback.call($this,mapEvent(event),data);
                }
            });

            housekeeper.on($this,'touchend',function(event){
                if (ignoreInput(TOUCH)) {
                    return;
                }
                blockDragMoveEvents = true;
                if (isDragging) {
                    callback.call($this,mapEvent(event),data);
                }
            });
        },

        // like mousemove with pressed left button especially for dragging (only left button / single Touch)
        dragmove: function (callback,data) {
            const $this = $(this);
            const housekeeper = Housekeeper($this,'dragmove',callback);

            const doMove = event => {
                if (!leftMouseButtonOrSingleTouch(event)) {
                    return;
                }
                if (blockDragMoveEvents) {
                    return;
                }
                const e = mapEvent(event);
                const dx = e.pageX - dragStartPosition.x;
                const dy = e.pageY - dragStartPosition.y;
                if (Math.sqrt(dx * dx + dy * dy) > 10) {
                    e.dragWasMoved = dragWasMoved = true;
                }
                callback.call($this,e,data);
            }

            housekeeper.on($this,'mousemove',function(event){
                if (ignoreInput(MOUSE)) {
                    return;
                }
                doMove(event);
            });

            housekeeper.on($this,'touchmove',function(event){
                if (ignoreInput(TOUCH)) {
                    return;
                }
                doMove(event);
            });
        },

        // entering an element during drag
        dragenter: dragEnterOrLeave('dragenter',function(inside,wasInside){
            return inside && !wasInside;
        }),

        // leaving an element during drag
        dragleave: dragEnterOrLeave('dragleave',function(inside,wasInside){
            return !inside && wasInside;
        }),

    };

    const eventsRegularExpression = new RegExp('^('+_.keys(events).join('|')+')$');

    function interceptJqueryHandler(handlerName,interceptor) {
        const oldFn = $.fn[handlerName];
        $.fn[handlerName] = function(eventName) {
            if ( typeof eventName==='string' && eventName.match && eventsRegularExpression.test(eventName) ) {
                interceptor($(this),eventName,_.slice(arguments,1));
            }
            return oldFn.apply( this, arguments );
        }
    }

    interceptJqueryHandler('on',function(jqThis,eventName,args) {
        const data = _.isFunction(args[0]) ? undefined : args[0];
        const callback = _.isFunction(args[0]) ? args[0] : args[1];
        return events[eventName].call( jqThis, callback, data );
    });

    interceptJqueryHandler('off',function(jqThis,eventName,args) {
        let callback = args.length>0?args[0]:undefined;
        // für off von onSafe
        if (callback && callback.originalCallback) {
            callback = callback && callback.originalCallback;
        }
        cleanup(jqThis,eventName,callback);
    });

})($);
